export default __webpack_public_path__ + "static/Betty-7aa6b8a4e72e95c22acd7c416b94c137.jpg";